import React from "react";
import { Link } from "react-router-dom";
import { inject } from "mobx-react";
import { Label, Row, Col } from "react-bootstrap";
import EntityDetailsModal from "../../modal-views/EntityDetailsModal";
import MaintenanceAgencyLabel from "./MaintenanceAgencyLabel";
import { StoreContext } from "../../contexts/StoreContext";

import "../../scss/components/detail/CubeStructureItem.scss";
import DateUtils from "src/utils/DateUtils";

const ITEMS_VIEW_LIMIT = 3;
const MAX_CHARACTER_TO_SHOW = 300;

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

@inject("detailViewStore", "previewStore", "popupStore")
export class CubeStructureItem extends React.Component {
  state = {
    showVariableDetailsModal: false,
    showAll: false,
    additionalClassnames: "csi-description-show-less",
    restrictionData: null,
    showButton: true,
    validityDate: null,
  };

  componentWillUnmount() {
    const { setCsiDescriptionField } = this.props.popupStore;
    setCsiDescriptionField("");
  }

  handleToggleDetailsModal = (restrictionData) => {
    const entityData = this.context.entityData;
    this.setState((oldState) => ({
      ...oldState,
      showVariableDetailsModal: !oldState.showVariableDetailsModal,
      restrictionData: restrictionData,
      validityDate: entityData?.item?.object ? DateUtils.figureOutValidityDate(entityData.item.object.validFrom, entityData.item.object.validTo) : null,
    }));
  };

  toggleShowAll = () => {
    const additionalClassnames = this.state.showAll
      ? "csi-description-show-less"
      : "";
    this.setState({
      showAll: !this.state.showAll,
      additionalClassnames: additionalClassnames,
    });
  };

  renderDescription = (variableDescription, csiDescriptionField) => {
    let text = variableDescription ? `${variableDescription}` : "";
    text += csiDescriptionField
      ? `\n- in the context on this Cube (table):\n`
      : "\n";
    text += csiDescriptionField ? `${csiDescriptionField}` : "";
    return (
      <div>
        <div
          className={`csi-description-field ${this.state.additionalClassnames}`}
          ref={(c) => (this.testComp = c)}
        >
          {text}
        </div>
        {this.state.showButton && text.length >= MAX_CHARACTER_TO_SHOW ? (
          <a
            className="show-all-toggle"
            href="https://"
            onClick={(event) => {
              event.preventDefault();
              this.toggleShowAll();
            }}
          >
            {this.state.showAll ? "Show less" : "Show all"}
          </a>
        ) : null}
      </div>
    );
  };
  static contextType = StoreContext;
  render() {
    const { setCsiDescriptionField } = this.props.popupStore;
    const { item } = this.props;
    if (!item.items || !item.items.length) {
      return null;
    }
    const { validityDate } = this.state;
    const variable = item.items.find((x) => x.object.type === "Variable");
    const subdomain = item.items.find((x) => x.object.type === "Subdomain");
    const variableSet = item.items.find((x) => x.object.type === "VariableSet");
    const member = item.items.find((x) => x.object.type === "Member");
    const csiDescription = item && item?.object && item?.object?.description;
    const csiDescriptionField =
      csiDescription && variable?.object?.description !== csiDescription
        ? csiDescription
        : "";

    let detailsItem = null;
    let items = null;
    let facetCollection = null;

    if (variableSet) {
      detailsItem = variableSet;
      items =
        variableSet.items && variableSet.items.length
          ? variableSet.items
              .map((vseItem) => vseItem.items)
              .reduce((acc, it) => [...acc, ...it]) // flatten list of nested items (subdomains, variables)
              .filter((x) => x.object.type === "Variable") // keep only variables
          : null;
    } else if (member) {
      detailsItem = member;
      items = [];
    } else if (subdomain) {
      facetCollection =
        subdomain.items &&
        subdomain.items.find((x) => x.object.type === "FacetCollection");
      if (facetCollection) {
        detailsItem = subdomain;
      } else {
        detailsItem = subdomain;
        items =
          subdomain.items && subdomain.items.length
            ? subdomain.items
                .filter((enumItem) => enumItem.items)
                .map((enumItem, key) => enumItem.items)
                .map((x) => x[0])
            : null;
      }
    }

    if (!detailsItem) {
      return null;
    }
    return (
      <>
        <Row>
          <Col xs={6}>
            {variable ? (
              <p className="CubeStructureItem__variable-name">
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleToggleDetailsModal(variable);
                    setCsiDescriptionField(csiDescriptionField);
                  }}
                  to={`/view/${variable.object.type}/${variable.object.tid}`}
                >
                  {/* TODO check if cubeVariableCode or code of variable */}
                  {`${variable.object.name || "[No name]"}`}
                </Link>
                {` (${item.object.cubeVariableCode}) `}
                <Label className="object-type" bsStyle="success">
                  {variable.object.type}
                </Label>
                {!item.object.isImplemented && !IS_BIRD_APP && (
                  <Label className={"object-implementation"} bsStyle="info">
                    LOGICAL
                  </Label>
                )}
                {variable.object.maintenanceAgencyId ? (
                  <MaintenanceAgencyLabel
                    maintenanceAgencyId={variable.object.maintenanceAgencyId}
                  ></MaintenanceAgencyLabel>
                ) : (
                  ""
                )}
                {"a" === item.object.role.toLowerCase() ? (
                  <span>
                    <br></br>
                    is related to {item.object.attributeAssociatedVariable}
                  </span>
                ) : null}
              </p>
            ) : null}
            {variable ? (
              <ul>
                <li>
                  {this.renderDescription(
                    variable.object.description,
                    csiDescriptionField
                  )}
                </li>
              </ul>
            ) : null}
          </Col>

          <Col xs={6}>
            <ul>
              <li>
                {
                  // Only display Subdomain description if there are no enumerated items
                  items && items.length > 0 ? null : (
                    <React.Fragment>
                      <p>
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            this.handleToggleDetailsModal(detailsItem);
                          }}
                          to={`/view/${detailsItem.object.type}/${detailsItem.object.tid}`}
                        >
                          {`${detailsItem.object.name || "[No name]"}`}
                        </Link>
                        {` (${detailsItem.object.code}) `}
                        <Label className="object-type" bsStyle="success">
                          {detailsItem.object.type}
                        </Label>
                        {detailsItem.object.maintenanceAgencyId ? (
                          <MaintenanceAgencyLabel
                            maintenanceAgencyId={
                              detailsItem.object.maintenanceAgencyId
                            }
                          ></MaintenanceAgencyLabel>
                        ) : (
                          ""
                        )}
                      </p>
                      {/* {detailsItem.object.description && (
                        <p>{detailsItem.object.description}</p>
                      )} */}
                    </React.Fragment>
                  )
                }

                {(items && items.length) || facetCollection ? (
                  <div>
                    <ul>
                      {items &&
                        items.length &&
                        items
                          .slice(0, ITEMS_VIEW_LIMIT)
                          .map((detailSubitem, index) => (
                            <li key={index}>
                              <p>
                                <Link
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.handleToggleDetailsModal(detailSubitem);
                                  }}
                                  to={`/view/${detailSubitem.object.type}/${detailSubitem.object.tid}`}
                                >
                                  {`${detailSubitem.object.name || "[No name]"}`}
                                </Link>
                                {` (${detailSubitem.object.code}) `}
                                <Label className="object-type" bsStyle="success">
                                  {detailSubitem.object.type}
                                </Label>
                                {detailSubitem.object.maintenanceAgencyId ? (
                                  <MaintenanceAgencyLabel
                                    maintenanceAgencyId={
                                      detailSubitem.object.maintenanceAgencyId
                                    }
                                  ></MaintenanceAgencyLabel>
                                ) : (
                                  ""
                                )}
                              </p>
                            </li>
                          ))}
                      {detailsItem.totalCountOfItems > 1 && (
                        <button
                          className="btn btn-link VariableDetailsModalToggleButton"
                          onClick={(e) => {
                            this.handleToggleDetailsModal(detailsItem);
                          }}
                        >
                          show all...{" "}
                          {detailsItem &&
                          detailsItem.totalCountOfItems >= ITEMS_VIEW_LIMIT
                            ? `(total ${detailsItem.totalCountOfItems} items)`
                            : ""}
                        </button>
                      )}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </li>
            </ul>
          </Col>
        </Row>
        {this.renderVariableDetailsModal(variable, item, validityDate)}
      </>
    );
  }

  renderVariableDetailsModal = (variable, cubeStructureItem, validityDate) => {
    return (
      <>
        {this.state.showVariableDetailsModal && (
          <StoreContext.Provider value={this.props.popupStore}>
            <EntityDetailsModal
              variable={variable}
              cubeVariableName={variable.object.name || "[No name]"}
              cubeVariableCode={cubeStructureItem.object.cubeVariableCode}
              CubeStructureItemData={cubeStructureItem}
              validityDate={validityDate}
              frameworkRelated={this.context.entityData.item.object.frameworkId}
              entityData={this.context.entityData}
              details={this.state.restrictionData}
              onClose={(e) => {
                this.handleToggleDetailsModal(this.state.restrictionData);
              }}
            />
          </StoreContext.Provider>
        )}
    </>
   )
  }
}
